export default "__VITE_ASSET__409a8540__"